// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* La 404 reutiliza el layout/animaciones de LogoutPageStyles.css
   (logout-container, logout-card, logout-text, logout-brand, logout-countdown,
   logout-actions, logout-footer y las keyframes pop/pulse/drawCircle/drawCheck).
   Aqui solo se define la variante de icono en ROJO para el error 404. */

.error-circle {
  width: 96px;
  height: 96px;
  border-radius: 50%;
  background: radial-gradient(circle at 30% 30%, rgba(229, 57, 53, 0.18), rgba(198, 40, 40, 0.08));
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  animation: pop 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) 0.1s both;
}

.error-circle::after {
  content: "";
  position: absolute;
  inset: -8px;
  border-radius: 50%;
  border: 2px solid rgba(198, 40, 40, 0.35);
  animation: pulse 2.2s ease-out infinite;
}

.error-cross {
  width: 72px;
  height: 72px;
}

.error-cross circle {
  stroke: #c62828;
  stroke-width: 2.5;
  stroke-dasharray: 166;
  stroke-dashoffset: 166;
  animation: drawCircle 0.7s cubic-bezier(0.65, 0, 0.45, 1) 0.15s forwards;
}

.error-cross path {
  stroke: #c62828;
  stroke-width: 4;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-dasharray: 36;
  stroke-dashoffset: 36;
  animation: drawCheck 0.4s cubic-bezier(0.65, 0, 0.45, 1) 0.7s forwards;
}

/* Barra de cuenta regresiva en rojo (la del logout es verde) */
.error-countdown-fill {
  background: linear-gradient(90deg, #e53935, #ef5350) !important;
}

@media (max-width: 480px) {
  .error-circle { width: 84px; height: 84px; }
  .error-cross  { width: 62px; height: 62px; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/404_page/404Page.css"],"names":[],"mappings":"AAAA;;;wEAGwE;;AAExE;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gGAAgG;EAChG,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,+DAA+D;AACjE;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,yCAAyC;EACzC,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,wEAAwE;AAC1E;;AAEA;EACE,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,sEAAsE;AACxE;;AAEA,+DAA+D;AAC/D;EACE,+DAA+D;AACjE;;AAEA;EACE,gBAAgB,WAAW,EAAE,YAAY,EAAE;EAC3C,gBAAgB,WAAW,EAAE,YAAY,EAAE;AAC7C","sourcesContent":["/* La 404 reutiliza el layout/animaciones de LogoutPageStyles.css\n   (logout-container, logout-card, logout-text, logout-brand, logout-countdown,\n   logout-actions, logout-footer y las keyframes pop/pulse/drawCircle/drawCheck).\n   Aqui solo se define la variante de icono en ROJO para el error 404. */\n\n.error-circle {\n  width: 96px;\n  height: 96px;\n  border-radius: 50%;\n  background: radial-gradient(circle at 30% 30%, rgba(229, 57, 53, 0.18), rgba(198, 40, 40, 0.08));\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  animation: pop 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) 0.1s both;\n}\n\n.error-circle::after {\n  content: \"\";\n  position: absolute;\n  inset: -8px;\n  border-radius: 50%;\n  border: 2px solid rgba(198, 40, 40, 0.35);\n  animation: pulse 2.2s ease-out infinite;\n}\n\n.error-cross {\n  width: 72px;\n  height: 72px;\n}\n\n.error-cross circle {\n  stroke: #c62828;\n  stroke-width: 2.5;\n  stroke-dasharray: 166;\n  stroke-dashoffset: 166;\n  animation: drawCircle 0.7s cubic-bezier(0.65, 0, 0.45, 1) 0.15s forwards;\n}\n\n.error-cross path {\n  stroke: #c62828;\n  stroke-width: 4;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-dasharray: 36;\n  stroke-dashoffset: 36;\n  animation: drawCheck 0.4s cubic-bezier(0.65, 0, 0.45, 1) 0.7s forwards;\n}\n\n/* Barra de cuenta regresiva en rojo (la del logout es verde) */\n.error-countdown-fill {\n  background: linear-gradient(90deg, #e53935, #ef5350) !important;\n}\n\n@media (max-width: 480px) {\n  .error-circle { width: 84px; height: 84px; }\n  .error-cross  { width: 62px; height: 62px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
